/**
 * Created by quikr on 8/26/16.
 */
import React, {Component} from "react";
import {Field, reduxForm} from "redux-form";
import Button from "react-bootstrap/lib/Button";
import * as actions from "../../../redux/actions/Attendance/attendanceActions";
import {DatePicker} from "redux-form-material-ui";
import MenuItem from "material-ui/MenuItem";
import SelectField from "material-ui/SelectField";

let min = new Date();
min.setDate(min.getDate() - 2);
let max = new Date();
max.setDate(max.getDate() - 1);
let from = new Date();
from.setDate(from.getDate() - 7);
let to = new Date();
var default_search = {
  startDate: from,
  endDate: to,
    regStatus: "pending"
};

class Form extends Component {
  constructor() {
    super();
    this.state = {error: "", request_object: default_search, regStatus: "pending"};
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    this.setState({
      startDate: date
    });
  }

  componentDidMount() {
    // on TextField
  }

  render() {


    const {handleSubmit, pristine, reset, submitting} = this.props;
    const formStyle = {
      paddingBottom: '0px',
      "font-family": '"ProximaNova-Regular", "sans-serif"'

    };


    return (
      <div style={{formStyle}}>

        <form onSubmit={handleSubmit(data => {

          if (data.startDate > data.endDate) {
            this.setState({error: "Check the Dates"});
            return;
          }
          if (this.props.dates.startDate == null && this.props.dates.endDate == null) {

          }

          else {
            let request = new Object();
            request.startDate = data.startDate ? data.startDate : this.props.dates.startDate;
            request.endDate = data.endDate ? data.endDate : this.props.dates.endDate;
            request.regStatus = this.state.regStatus ? this.state.regStatus : null;
            this.props.dispatch(actions.getRegularisationAttendance(request));
            this.props.change_date(request);
            this.setState({error: "", request_object: request});

            return;
          }

        })}>

          <div className="col-md-12">
            <div className="col-md-3">
              <img src="/public/images/calendar.png" style={{paddingRight: '10'}}/>

              <Field name="startDate"
                     inputStyle={{color: 'black'}}
                     container="inline"
                     dialogContainerStyle={{color: 'black', padding: 0}}
                     className="rowX"
                     component={DatePicker}
                     autoOk={true}
                     shouldDisableDate={
                       (day)=> {
                         if (day.getDay() != 1)
                           return true;
                       }
                     }
                     defaultValue={this.props.dates.startDate}
                     style={{
                       display: 'inline',
                       "font-family": '"ProximaNova-Regular", "sans-serif"',
                       padding: 0,
                       margin: 0,
                       color: 'red'
                     }}
                     mode={'portrait'}
                     textFieldStyle={{width: '80%', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                     maxDate={new Date()}
                     formatDate={(date)=> {
                       return (date.toString().substring(0, 16));
                     }}

                // DatePicker requires an object,
                // and redux-form defaults to ''
                     floatingLabelText="Start Date"
                     hintText="Start Date "/>

            </div>

            <div className="col-md-3">
              <img src="/public/images/calendarO.png" style={{paddingRight: '10'}}/>
              <Field name="endDate"
                     container="inline"
                     style={{display: 'inline', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                     component={DatePicker}
                     autoOk={true}
                     defaultValue={this.props.dates.endDate}
                     shouldDisableDate={
                       (day)=> {
                         if (day.getDay() != 1)
                           return true;
                       }
                     }


                     floatingLabelText="End Date"
                     textFieldStyle={{width: '80%', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                     mode={'portrait'}

                     maxDate={new Date()}

                     formatDate={(date)=> {
                       return (date.toString().substring(0, 16));
                     }}

                // and redux-form defaults to ''
                     hintText="End Date "/>

            </div>

            <div className="col-md-3 form-group form-select-hrms">
                <SelectField
                    name="regStatus"
                    style={{display: 'inline-block', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                    textFieldStyle={{width: '80%', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                    floatingLabelText="Regularisation Status"
                    value={this.state.regStatus}
                    onChange={(option, data, value)=> {
                        this.setState({regStatus: value});
                    }}
                    hintText="Regularisation Status" >
                    <MenuItem value={null} primaryText="All"/>
                    <MenuItem value={"pending"} primaryText="Pending"/>
                    <MenuItem value={"apply"} primaryText="Applied"/>
                    <MenuItem value={"approved"} primaryText="Approved"/>
                    <MenuItem value={"rejected"} primaryText="Rejected"/>
                    <MenuItem value={"re-regularize"} primaryText="Re-Regularize"/>
                </SelectField>
            </div>

            <div style={{marginTop: '25px'}} className="col-md-2">
              <Button
                backgroundColor="#008bcf"
                className="btn btn-default btn-lg"
                type="submit"
                disabled={false}><font
                style={{"font-family": '"ProximaNova-Regular", "sans-serif"', color: 'white'}}><b>Search</b></font>
                <img src="/public/images/magnifying-glass.png"
                     style={{'paddingLeft': '6px'}}
                />
              </Button>
              {this.state.error.length == 0 ? <label></label> : <label style={{
                color: 'red',
                paddingLeft: '5px',
                "font-family": '"ProximaNova-Regular", "sans-serif"'
              }}>{this.state.error}</label>}
            </div>


          </div>


        </form>

      </div>
    )
  }
}

export default reduxForm({
  form: 'example',

})(Form)




/** WEBPACK FOOTER **
 ** ./src/feature/attendance/MyAttendance/RegSearchForm.js
 **/